const items = [
  { icon: 'ri-award-fill', label: 'CSIA Certified', sub: 'Chimney Safety Institute' },
  { icon: 'ri-wind-fill', label: 'NADCA Certified', sub: 'Air Duct Cleaners Assoc.' },
  { icon: 'ri-shield-check-fill', label: 'Licensed & Insured', sub: 'Florida State Licensed' },
  { icon: 'ri-star-fill', label: '500+ Five-Star Reviews', sub: 'Google & Yelp verified' },
  { icon: 'ri-calendar-check-fill', label: 'Same-Week Availability', sub: 'Mon – Sat scheduling' },
  { icon: 'ri-home-heart-fill', label: 'Local Since 2010', sub: 'Jacksonville, FL owned' },
];

export default function TrustBar() {
  return (
    <section className="relative bg-brand-dark overflow-hidden">
      {/* Subtle amber accent line */}
      <div className="h-0.5 bg-gradient-to-r from-transparent via-brand-amber to-transparent" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div className="flex flex-wrap items-center justify-center xl:justify-between gap-x-6 gap-y-4">
          {items.map((item, i) => (
            <div key={item.label} className="flex items-center gap-3 group">
              {i > 0 && <div className="hidden xl:block h-8 w-px bg-white/10" />}
              <div className="w-9 h-9 flex items-center justify-center bg-brand-amber/15 group-hover:bg-brand-amber/25 rounded-lg transition-colors flex-shrink-0">
                <i className={`${item.icon} text-brand-amber text-base`} />
              </div>
              <div>
                <div className="text-white text-sm font-semibold leading-none mb-0.5">{item.label}</div>
                <div className="text-white/45 text-xs">{item.sub}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="h-0.5 bg-gradient-to-r from-transparent via-white/5 to-transparent" />
    </section>
  );
}
